export default __webpack_public_path__ + "static/media/htpf.6177e8ec.png";